import React, { useEffect, useState } from 'react';
import axios from 'axios';
import get from 'lodash/get';
import { uniqueId } from 'lodash';
import { SdfBusyIndicator } from '@synerg/react-components';
import CertificateView from './from-shared-comp/Certificate/CertificateView';
import Toast from '../common/toast';
import { withNotificationContext } from '../shared/notifications';
import { useHistory } from 'react-router-dom';

const Certificate = ({ setShowNotificationMenu, email }) => {
  const history = useHistory();
	const [isBusy, setIsBusy] = useState(false);
	const [orgName, setOrgName] = useState('');
	const [toast, setToast] = useState(false);

	const handleResponse = (message, status = "error") => {
		setToast({
			key: uniqueId(),
			status: status,
			message: message,
			showToast: true
		});
	};

	const fetchCertificates = async () => {
		return axios.get(`${import.meta.env.VITE_ROOT_PATH}/api/partner/certificates`);
	};

	const getCertificate = async (certID) => {
		return axios.get(`${import.meta.env.VITE_ROOT_PATH}/api/certificates/${certID}`);
	};

	const onDelete = async (certID) => {
		return axios.delete(`${import.meta.env.VITE_ROOT_PATH}/api/certificates/${certID}`);
	};

	const onUpload = async (formData) => {
		return axios({
			method: 'post',
			url: `${import.meta.env.VITE_ROOT_PATH}/api/partner/certificates`,
			data: formData,
			headers: { 'Content-Type': 'multipart/form-data' }
		})
	};

	const retry = async (certID) => {
		return axios.post(`${import.meta.env.VITE_ROOT_PATH}/api/certificates/${certID}/retry-enrollment`)
	};

	const generateCert = async (certData) => {
		return axios.post(`${import.meta.env.VITE_ROOT_PATH}/api/certificates/generate`, certData);
	};

	const submitReq = async (requestData) => {
		return axios.post(`${import.meta.env.VITE_ROOT_PATH}/api/certificates/submit-automated-certificate-request`, {
			certificateRequest: requestData
		});
	};

	useEffect(() => {
		const getData = async () => {
			setIsBusy(true);
			try {
				const { data } = await axios(`${import.meta.env.VITE_ROOT_PATH}/api/partner/organization/name`);
				if (data && data.orgName) {
					setOrgName(data.orgName);
				}
				setIsBusy(false);
			} catch (e) {
				const errorMessage = get(e, 'response.data.message', 'Unable to retrieve organization name. Please try again.');
				handleResponse(errorMessage);
				setIsBusy(false);
			}
		};
		getData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);


	return (
		<div>
			{isBusy && <SdfBusyIndicator style={{ color: "#1a8099" }} size="lg" overlay={true} fullScreen={false} />}
			{toast && <Toast
				key={toast.key}
				status={toast.status}
				message={toast.message}
				showToast={toast.showToast}
			/>}
			<CertificateView
				orgName={orgName}
				email={email}
				setIsBusy={setIsBusy}
				handleResponse={handleResponse}
				fetchCertificates={fetchCertificates}
				getCertificate={getCertificate}
				onDelete={onDelete}
				onUpload={onUpload}
				retry={retry}
				generateCert={generateCert}
				submitReq={submitReq}
				setShowNotificationMenu={setShowNotificationMenu}
        history={history}
			/>
		</div>
	);
}

export default withNotificationContext(Certificate);
